import { Button, Group, Title } from "@mantine/core";
import { modals } from "@mantine/modals";
import { IconMailPlus, IconMessagePlus } from "@tabler/icons-react";
import { useNavigate } from "@tanstack/react-router";
import { OptInUserFormProvider, useOptInUserFormContext } from "shared/components/opt-in/context";
import { CreateEudPanel } from "shared/components/opt-in/CreateEudPanel";
import { VerifyEudPanel } from "shared/components/opt-in/VerifyEudPanel";
import { notify } from "shared/utils/notify";
import { Cm } from "src/gql/graphql";

export const AddEudPanel = () => {
    const nav = useNavigate();
    const form = useOptInUserFormContext();

    return (
        <Group wrap="nowrap" w="100%">
            <Button
                variant="default"
                fullWidth
                leftSection={<IconMailPlus size={16} />}
                flex={1}
                onClick={() => {
                    modals.open({
                        title: <Title order={4}>Add Email</Title>,
                        children: (
                            <OptInUserFormProvider form={form}>
                                <CreateEudPanel
                                    type={Cm.Email}
                                    onCreated={(eudId) => {
                                        modals.closeAll();
                                        modals.open({
                                            title: <Title order={4}>Verify Email</Title>,
                                            children: (
                                                <OptInUserFormProvider form={form}>
                                                    <VerifyEudPanel
                                                        type={Cm.Email}
                                                        eudId={eudId}
                                                        onConflict={() => {
                                                            modals.closeAll();
                                                            void notify
                                                                .confirm(
                                                                    "The email you entered is associated with an existing user and will receive alerts. To manage this user please log in or create an account.",
                                                                    { label: "Continue to Login", title: "Existing Email" },
                                                                )
                                                                .then(({ close }) => close())
                                                                .then(() => nav({ to: "/opt-in" }));
                                                        }}
                                                    />
                                                </OptInUserFormProvider>
                                            ),
                                        });
                                    }}
                                />
                            </OptInUserFormProvider>
                        ),
                    });
                }}
            >
                Email Me
            </Button>

            <Button
                variant="default"
                fullWidth
                leftSection={<IconMessagePlus size={16} />}
                flex={1}
                onClick={() => {
                    modals.open({
                        title: <Title order={4}>Add Text Phone Number</Title>,
                        children: (
                            <OptInUserFormProvider form={form}>
                                <CreateEudPanel
                                    type={Cm.Sms}
                                    onCreated={(eudId) => {
                                        modals.closeAll();
                                        modals.open({
                                            title: <Title order={4}>Verify Text Phone Number</Title>,
                                            children: (
                                                <OptInUserFormProvider form={form}>
                                                    <VerifyEudPanel
                                                        type={Cm.Sms}
                                                        eudId={eudId}
                                                        onConflict={() => {
                                                            modals.closeAll();
                                                            void notify
                                                                .confirm(
                                                                    "The phone number you entered is associated with an existing user and will receive alerts. To manage this user please log in or create an account.",
                                                                    { label: "Continue to Login", title: "Existing Phone Number" },
                                                                )
                                                                .then(({ close }) => close())
                                                                .then(() => nav({ to: "/opt-in" }));
                                                        }}
                                                    />
                                                </OptInUserFormProvider>
                                            ),
                                        });
                                    }}
                                />
                            </OptInUserFormProvider>
                        ),
                    });
                }}
            >
                Text Me
            </Button>
        </Group>
    );
};
